// Main js file for the object
function product() {
  console.log('product');
}

export default product;
